<script setup>

import {onMounted, ref, useSlots} from "vue";

const props = defineProps({
    teleport: {
        type: Boolean,
        default: true,
    },
    breadcrumbs: {
        type: Array,
        required: false,
        default: [],
    }
});

const slots = useSlots();
const mounted = ref(false);

onMounted(() => {
    mounted.value = true;
});
</script>

<template>
    <teleport
        v-if="mounted"
        to="#teleport-target-sticky-before-main"
        :disabled="!props.teleport"

    >
        <div class="relative bg-white z-20 border-b border-gray-200">
            <div
                class="px-4 py-2 min-h-12 grid grid-cols-1 items-center"
                id="frosted-bar-contents"
            >
                <div
                    v-if="breadcrumbs.length > 0"
                    class="pb-1 -mt-2 pt-1 -mx-4 -mr-2 pl-4 pr-2"
                >
                    <nav class="block text-xxs text-gray-500">
                        <ul class="flex">
                            <li
                                v-for="(crumb, index) in breadcrumbs"
                                :key="index"
                            >
                                <a
                                    v-if="crumb.url"
                                    :href="crumb.url"
                                    class="hover:text-gray-700 text-brandPrimary-400"
                                >
                                    {{ crumb.label }}
                                </a>
                                <span
                                    v-else
                                    class=""
                                >
                                    {{ crumb.label }}
                                </span>
                                <span v-if="breadcrumbs.length > index + 1" class="mx-1 text-gray-400">
                                    <i class="fa-solid fa-angle-right"></i>
                                </span>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div
                    v-if="slots.navigation"
                    class="pb-1 -mt-2 pt-1 -mx-4 -mr-2 pl-4 pr-2 text-xs text-brandPrimary-400"
                >
                    <slot name="navigation"></slot>
                </div>
                <slot></slot>
            </div>
            <div id="top-bar-tab-bar" class="overflow-hidden border-t border-gray-100 empty:border-t-0"></div>
        </div>
    </teleport>
</template>

<style scoped>
:deep h1 {
    font-size: 14px !important;
}
</style>
